import { Alert } from "@instructure/ui-alerts";
import { useTranslation } from "react-i18next";

const NotAuthorized = () => {
  const { t } = useTranslation();
  return <Alert variant="error">{t("errorPage.noAccess")}</Alert>;
};

export default NotAuthorized;
